fx.ns("desktop.common.zoom", class ZoomBar extends fx.Component{
    
	constructor(model)
	{
		super();

		this.model = model;
	}

	onReady()
	{
		this.zoomOutBtn = this.find(".zoom-out");
		this.zoomInBtn = this.find(".zoom-in");
		this.zoomValueBtn = this.find(".zoom-value");
		this.closeBtn = this.find(".close");
		
		this.on("updated", this.onDisplayUpdated, this.model.zoom);

		if (this.zoomOutBtn)
			this.on("click", this.onZoomOut, this.zoomOutBtn);

		if (this.zoomInBtn)
			this.on("click", this.onZoomIn, this.zoomInBtn);

		if (this.zoomValueBtn)
			this.on("click", this.onZoomValue, this.zoomValueBtn);

		if (this.closeBtn)
			this.on("click", this.onClose, this.closeBtn);
	}

	
	onDisplayUpdated()
	{
		super.onDisplayUpdated();
		
		if (!this.zoomOutBtn) return;

		this.zoomValueBtn.innerHTML = this.model.zoom.value + "%";

		this.toggleClass(this.zoomOutBtn, "disabled", !this.model.zoom.canZoomOut );
		this.toggleClass(this.zoomInBtn, "disabled", !this.model.zoom.canZoomIn );
	}

	destroy()
	{
		super.destroy();
		
	}

	render() 
	{
		let html = "";
		
		html += '<div class="action hover close">' + fx.text("Fermer") + '</div>';
		html += '<div class="v-separator"></div>';
		
		html += '<div class="action hover zoom-out">' + fx.assets.ZoomOutIcon.render() + '</div>';
		html += '<div class="action hover zoom-value">100%</div>';
		html += '<div class="action hover zoom-in">' + fx.assets.ZoomInIcon.render() + '</div>';
	
	
		return html;
	}



	onZoomOut()
	{
		this.model.zoom.out();

		if (this.model.zoom.value == 100)
			this.trigger("close");
	}

	onZoomIn()
	{
		this.model.zoom.in();	
	}

	onZoomValue()
	{
		//this.model.zoom.editionView();
		this.trigger("close");
	}

	onClose()
	{
		//this.model.event("preview");
		this.trigger("close");
	}

});